import styles from "../styles/BtnStatus.module.css";

export default function BtnStatusCloudbeds({
  status,
  status_nome,
  jsoncloudbeds_error = null,
  onclick = null,
}) {
  if (status == "confirmed") {
    var btnclass = styles.confirmed;
  } else if (status == "not_confirmed") {
    var btnclass = styles.not_confirmed;
  } else if (status == "canceled") {
    var btnclass = styles.canceled;
  } else if (status == "checked_in") {
    var btnclass = styles.checked_in;
  } else if (status == "checked_out") {
    var btnclass = styles.checked_out;
  } else if (status == "no_show") {
    var btnclass = styles.no_show;
  } else if (status == "error") {
    var btnclass = styles.error;
  }

  return (
    <button
      className={`${styles.btn} ${btnclass}`}
      data-tip={jsoncloudbeds_error != null ? jsoncloudbeds_error : ""}
      onClick={() => {
        onclick();
      }}
    >
      {status_nome}
    </button>
  );
}
